import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-3">
            专题聚焦
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精选专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的电影专题，发现更多值得看的高清大片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 font-medium mb-3">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-500 group-hover:gap-3 transition-all">
                  浏览专题
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}